import React from 'react';
import Header from '../components/Header';
import Banner from '../components/Banner';
import FeaturedSection from '../components/FeaturedSection';
import ProductCard from '../components/ProductCard';
import Footer from '../components/Footer';
import HomeContact from '../components/HomeContact.jsx';
import SideCol from '../components/SideCol.jsx';
import axios from 'axios';
import { useEffect, useState } from 'react';
// CSS imports (relative path goes up one level to access assets)
import '../assets/css/animate.css';
import '../assets/css/flex-slider.css';
import '../assets/css/fontawesome.css';
import '../assets/css/owl.css';
import '../assets/css/templatemo-villa-agency.css';
// JS imports
import '../assets/js/counter.js';
import '../assets/js/custom.js';
import '../assets/js/isotope.min.js';
import '../assets/js/owl-carousel.js';
import './style.css';
function Home() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://trinoxabrasives.com/api/products/');
        setProducts(response.data.results);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, [])
  return (
    <div className="home-page">
      <Header />
      <Banner />
      <FeaturedSection />
      <div className="properties section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 offset-lg-4">
              <div className="section-heading text-center">
                <h6>| Properties</h6>
                <h2>We Provide The Best Grinding Wheels You Like</h2>
              </div>
            </div>


            <h2>CUT OFF WHEELS</h2>
            <div className='row'>
              {products.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <HomeContact />
      <Footer />
      <SideCol />
    </div>
  );
}

export default Home;